import React from 'react';

import Button from '@hpstellar/core/Button';
import Dropdown from '@hpstellar/core/Dropdown';
import Counter from '@hpstellar/core/Counter';

import './sort-bar.less';

export default function sortBar({ filterCount, clear, vwaDetails, sortValues, onSort }) {
    return (
        <div className="sortBar">
            <div className="filterCount">
                {filterCount > 0 && (
                    <>
                        <Counter className="counter" count={filterCount} size="small" subsetDelimiter="of">
                            FILTER APPLIED
                        </Counter>
                        <Button className="clear" variation="tertiary" onClick={clear} icon="remove">
                            CLEAR ALL
                        </Button>
                    </>
                )}
            </div>
            <div className="productCount">
                <Counter className="counter" count={vwaDetails.totalProducts} size="large" subsetDelimiter="of">
                    Results
                </Counter>
            </div>
            <Dropdown
                className="sortDropdown"
                options={sortValues.map(sort => ({ label: sort.title, value: sort.key }))}
                onChange={onSort}
                label="Sort by"
                defaultValue={vwaDetails.orderBy}
            />
        </div>
    );
}
